export const formatRole = (role: string) => {
  if (role.toLowerCase() === "superadmin") {
    return "Super Admin";
  }
  return role.charAt(0).toUpperCase() + role.slice(1).toLowerCase();
};
